var path = 'app/scripts/modules/google/src/pipeline/stages/tagImage/tagImageStage.html';
var html = "<div ng-controller=\"gceTagImageStageCtrl as tagImageStageCtrl\" class=\"form-horizontal\">\n  <stage-config-field label=\"Account\">\n    <account-select-field\n      component=\"stage\"\n      field=\"credentials\"\n      accounts=\"accounts\"\n      provider=\"'gce'\"\n      required>\n    </account-select-field>\n  </stage-config-field>\n  <stage-config-field label=\"Tags\">\n    <map-editor model=\"stage.tags\" allow-empty=\"true\"></map-editor>\n  </stage-config-field>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/google/src/pipeline/stages/tagImage/tagImageStage.html
// module id = 1336
// module chunks = 0